export default __webpack_public_path__ + "static/media/link2.bb54c10f.svg";